import React, { useRef } from 'react';

import { UserOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';

import { PrimaryBlackButton, TertiaryButton } from '../../components/Button/Buttons';
import HeaderCollapsibleSegment from '../../components/CollapsibleSegment/HeaderCollapsibleSegment';
import CompanyLogo from '../../components/CompanyLogo/CompanyLogo';
import LargeCloseIcon from '../../components/Icons/LargeCloseIcon';
import { InternalNavLink } from '../../components/Link/Link';
import { configSetting } from '../../config';
import { navConfig } from '../navConfig';
// import { PrimaryBlackButton } from '../../components/Button/Buttons';
import { useNavigate } from 'react-router-dom';
import { CONTACT } from '../../routes/routeConstants';

interface IHamburgerMenu {
  open: boolean;
  toggleNav: (...arg: any) => void;
}

const HamburgerMenu: React.FC<IHamburgerMenu> = ({ open, toggleNav }) => {
  const navigate = useNavigate()
  const bgRef = useRef(null);
  const handleNavMenuItemClick = (_: any) => {
    toggleNav();
  };

  const handleBgClick = (e: any) => {
    if (bgRef && bgRef.current === e.target) {
      toggleNav();
    }
  };

  return (
    <MainContainer
      ref={bgRef}
      className={open ? '' : 'close'}
      onClick={handleBgClick}
    >
      <Container className={open ? '' : 'close'}>
        <Header>
          <CompanyLogoWrapper onClick={handleNavMenuItemClick}>
            <CompanyLogo smallLogo />
          </CompanyLogoWrapper>
          <CloseIconContainer
            className={open ? 'open' : ''}
            onClick={toggleNav}
          >
            <LargeCloseIcon />
          </CloseIconContainer>
        </Header>

        <NavElementContainer>
          {navConfig.map((nav, index) => {
            if (nav.title === 'Services') {
              return (
                <HeaderCollapsibleSegment
                  key={index}
                  title='Services'
                  onClick={handleNavMenuItemClick}
                  data={navConfig[2].dropDownItems}
                />
              );
            }
            return (
              <InternalNavLink
                to={nav?.path ?? ''}
                key={nav.title}
                onClick={handleNavMenuItemClick}
                className='hamburger'
              >
                {nav.title}
              </InternalNavLink>
            );
          })}
          <ButtonWrapper>
            <TertiaryButton
              onClick={() => {
                    window.location.href = `${configSetting.dashboardUrl}/account/signin`;
              }}
            >
              <UserOutlined />
              Sign In
            </TertiaryButton>
            <PrimaryBlackButton
              onClick={() => { navigate(`/${CONTACT}`); toggleNav(); }}
            >
              Contact Us
            </PrimaryBlackButton>
          </ButtonWrapper>
        </NavElementContainer>
      </Container>
    </MainContainer>
  );
};

export default HamburgerMenu;

const MainContainer = styled.div`
  display: None;
  height: 100vh;
  position: fixed;
  background: rgba(0, 0, 0, 0.4);

  @media (max-width: 884px) {
    width: 100vw;
    display: flex;
    margin-left: auto;
    z-index: 20000;

    &.open {
      transform: translateX(0);
    }

    &.close {
      transform: translateX(100%);
      opacity: 0;
      transition: transform 0s ease-in-out 0.3s, opacity 0.3s ease-in-out 0.1s;
    }
  }
`;

const Container = styled.nav`
  display: flex;
  padding: 32px;
  background-color: white;
  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;

  flex-direction: column;
  gap: 3.8rem;
  height: 100vh;
  position: absolute;
  width: 347px;
  top: 0;
  right: 0;

  gap: 31px;

  &.open {
    transform: translateX(0);
  }

  &.close {
    transform: translateX(100%);
  }

  @media (max-width: 320px) {
    width: 300px;
  }
`;

const CompanyLogoWrapper = styled.div`
  display: flex;
  margin: 0rem;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const CloseIconContainer = styled.div`
  color: black;
  margin-top: 0.5rem;
  cursor: pointer;
`;

const NavElementContainer = styled.div`
  display: flex;
  gap: 2rem;
  flex-direction: column;

  @media screen and (max-width: 884px) {
    gap: 40px;
  }
`;

const ButtonWrapper = styled.div`
  margin-top: 29px;
  display: flex;
  flex-direction: column;
  gap: 33px;
`;
